import { render, staticRenderFns } from "./VODPoolsDetail.vue?vue&type=template&id=39796f1b&scoped=true&"
import script from "./VODPoolsDetail.vue?vue&type=script&lang=js&"
export * from "./VODPoolsDetail.vue?vue&type=script&lang=js&"
import style0 from "./VODPoolsDetail.vue?vue&type=style&index=0&id=39796f1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39796f1b",
  null
  
)

export default component.exports